<script setup>
  import { format } from "date-fns";
  import { computed, ref } from "vue";

  import IcSearch from "@/assets/images/svg-component/IcSearch.vue";
  import { formatTwoDigits, handleMonitoringStatusChipOption } from "@/utils";

  import MonitoringDetailModal from "./MonitoringDetailModal.vue";

  const props = defineProps({
    index: { type: Number, default: -1 },
    item: { type: Object, required: true },
    examStatus: { type: String, required: true },
    qCount: { type: Number, required: true },
    nextTour: { type: Function, required: true },
  });

  // 상태
  const chipOption = computed(() => {
    return handleMonitoringStatusChipOption(props.item.status);
  });

  // 시험 시간
  const handleExamTimeText = (startTime, endTime) => {
    if (!startTime && !endTime) return "";

    const startDateText = startTime ? format(startTime, "yyyy.MM.dd") : "";
    const endDateText = endTime ? format(endTime, "yyyy.MM.dd") : "";
    const startTimeText = startTime ? format(startTime, "yy.MM.dd HH:mm") : "";
    let endTimeText = "";

    if (endTime) {
      // 날짜가 같으면 시간만 표시
      if (startDateText && startDateText === endDateText) {
        endTimeText = format(endTime, "HH:mm");
      } else {
        endTimeText = format(endTime, "yy.MM.dd HH:mm");
      }
    }
    return `${startTimeText} - ${endTimeText}`;
  };

  // 상세모달
  const isOpenDetailModal = ref(false);
  const openDetailModal = () => {
    isOpenDetailModal.value = true;
  };
  const closeDetailModal = () => {
    isOpenDetailModal.value = false;
  };

  defineExpose({
    closeDetailModal,
  });
</script>

<template>
  <div
    :id="'tour-exmne-' + item.number"
    class="monitoring-card"
    @click="openDetailModal(item)"
  >
    <n-icon :size="16" class="ic-search"><IcSearch /> </n-icon>
    <div>
      <ui-chip
        :color="chipOption.color"
        :variant="chipOption.variant"
        size="sm"
        >{{ item.status }}</ui-chip
      >
      <n-flex :size="8" class="mt-1 text-lg">
        <span class="text-gray-500">{{ formatTwoDigits(item.number) }}</span>
        <strong class="text-gray-800">{{ item.name }}</strong>
      </n-flex>
    </div>
    <div class="additional-info">
      <small v-if="item.applyStartTime"
        >시험 시간:
        {{ handleExamTimeText(item.applyStartTime, item.applyEndTime) }}</small
      >
      <small class="q-solved-total" v-if="item.solvedCount">
        푼 문제 수: {{ item.solvedCount }} / {{ qCount }}
      </small>
    </div>
  </div>
  <MonitoringDetailModal
    v-model:show="isOpenDetailModal"
    :examStatus="examStatus"
    :item="item"
    :next-tour="nextTour"
  />
</template>

<style lang="scss" scoped>
  .monitoring-card {
    border: 1px solid var(--smoe-border);
    padding: 1rem;
    border-radius: 0.5rem;
    height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    transition: 0.1s ease-in-out;
    cursor: pointer;
    .ic-search {
      opacity: 0;
      visibility: hidden;
      position: absolute;
      right: 1rem;
      top: 1rem;
    }
    .additional-info {
      color: var(--smoe-gray-500);
      small {
        display: block;
        font-size: 0.75rem;
        margin-top: 0.25rem;
      }
      .q-solved-total {
        display: inline-flex;
        background: var(--smoe-gray-100);
        padding: 0.125rem 0.5rem;
        border-radius: 100px;
        color: var(--smoe-gray-700);
        font-weight: 600;
        transition: 0.1s ease-in-out;
      }
    }
    &:hover {
      border-color: var(--var-gray-400);
      .ic-search {
        opacity: 1;
        visibility: visible;
      }
    }
  }
</style>
